export const version = "2.0.0-20261102";
export const commit = "2787d58a4cd2c62ec7ed446f8016aa0136011a2b";
